// API base URL is injected at build time via webpack DefinePlugin (see webpack.config.js).
// Falls back to the local mock server (mock-server.ts on port 3001) for local development.
export const apiBaseUrl: string = __API_BASE_URL__;

// OIDC configuration injected at build time via webpack DefinePlugin.
// Values are provided per environment by the CI build job. Empty values mean
// OIDC is not configured yet (login is then effectively disabled).
export const oidcConfig = {
  authorizationEndpoint: __OIDC_AUTHORIZATION_ENDPOINT__,
  tokenEndpoint: __OIDC_TOKEN_ENDPOINT__,
  userInfoEndpoint: __OIDC_USERINFO_ENDPOINT__,
  logoutEndpoint: __OIDC_LOGOUT_ENDPOINT__,
  clientId: __OIDC_CLIENT_ID__,
  scope: __OIDC_SCOPE__,
} as const;

export const isOidcConfigured: boolean = Boolean(
  oidcConfig.authorizationEndpoint &&
    oidcConfig.tokenEndpoint &&
    oidcConfig.clientId,
);
